
import React from 'react';
import { Task } from '@/types/task';
import { TaskColumn } from '../TaskColumn';

interface DesktopViewProps {
  tasksByDay: Record<string, Task[]>;
  unscheduledTasks: Task[];
  currentDayName: string;
  onNavigate: (direction: 'prev' | 'next') => void;
  isAdmin: boolean;
  onComplete: (task: Task) => void;
  onDelete: (taskId: string) => void;
  onEdit: (taskId: string, data: any) => void;
  onReactivate?: (task: Task) => void;
}

export const DesktopView = ({
  tasksByDay,
  unscheduledTasks,
  currentDayName,
  isAdmin,
  onComplete,
  onDelete,
  onEdit,
  onReactivate
}: DesktopViewProps) => {
  return (
    <div className="grid grid-cols-4 gap-4 overflow-x-auto w-full">
      <TaskColumn
        key="unscheduled"
        day="To Do This Week"
        tasks={unscheduledTasks}
        isAdmin={isAdmin}
        onComplete={onComplete}
        onDelete={onDelete}
        onEdit={onEdit}
        onReactivate={onReactivate}
      />
      
      {Object.entries(tasksByDay).map(([day, dayTasks]) => (
        <TaskColumn
          key={day}
          day={day}
          tasks={dayTasks}
          isToday={day === currentDayName}
          isAdmin={isAdmin}
          onComplete={onComplete}
          onDelete={onDelete}
          onEdit={onEdit}
          onReactivate={onReactivate}
        />
      ))}
    </div>
  );
};
